import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

export default function CtaSection() {
  return (
    <section className="bg-foreground-950 px-4 md:px-10 py-24 md:py-32">
      <div className="text-center">
        <Reveal>
          <h2 className="mx-auto max-w-3xl font-heading text-3xl md:text-5xl tracking-tight text-background-50">
            Ready to make something worth watching?
          </h2>
        </Reveal>
        <Reveal delay={140}>
          <Link
            to="/contact"
            className="mt-9 inline-block whitespace-nowrap rounded-md bg-background-50 px-8 py-4 font-label text-xs tracking-[0.2em] uppercase text-foreground-950 transition-colors duration-200 hover:bg-accent-400 hover:text-accent-950"
          >
            Start the Conversation
          </Link>
        </Reveal>
      </div>
    </section>
  );
}